import "./AddUserModal.css"; // Arquivo CSS para estilos
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução
import { AuthContext } from "../../../authContext";
import { useState, useContext, useEffect } from 'react';
import AlertsCustom from '../../Alerts/index'

const AddUserModal = ({ isOpen, setShowAddUserModal, tempUsersList, setTempUsersList, allUsers, setAllUsers, size = 'default', role, showEmailModeButton = true, showFooterButtons = true, assistantId, showAddByEmailInput = true }) => {
    const { accessToken } = useContext(AuthContext);
    const { t: tSelfAssist } = useTranslation('assistantConfiguration');
    const { t: tCommon } = useTranslation('common');
    const [addByEmailMode, setAddByEmailMode] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [allowedDomains, setAllowedDomains] = useState([]);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [emailToAdd, setEmailToAdd] = useState("");

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/get_domains`)
            .then(response => response.json())
            .then(data => {
                const onlyDomains = data.map(d => d.dominio.toLowerCase().trim());
                setAllowedDomains(onlyDomains);
            })
            .catch(err => console.error("Erro ao buscar domínios permitidos:", err));
    }, []);



    if (!isOpen) return null;

    const isAllowedDomain = (email) => {
        const domain = email.split('@')[1].toLowerCase().trim();
        const normalizedDomains = allowedDomains.map(d => d.toLowerCase().trim());
        return normalizedDomains.includes(domain);
    };

    const handleSearchEnter = async (e) => {
        if (e.key !== 'Enter') return;

        const email = searchTerm.trim();

        // Verifica se o e-mail é válido
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!isValidEmail) {
            //alert("Digite um e-mail válido");
            setAlertTitle("Erro");
            setAlertType("error");
            setAlertMessage(tSelfAssist('email_valido'));
            setShowAlert(true);
            return;
        }

        if (!isAllowedDomain(email)) {
            //alert(`Este domínio não está permitido`);
            setAlertTitle("Erro");
            setAlertType("error")
            setAlertMessage(tSelfAssist('dominio_valido'))
            setShowAlert(true);
            return;
        }

        // Se estiver no modo de adicionar por e-mail
        if (addByEmailMode) {
            // Verifica se já existe na lista
            const alreadyInList = tempUsersList.some(u => u.email === email);
            if (alreadyInList) {
                //alert("Este e-mail já foi adicionado.");
                setAlertTitle("Erro");
                setAlertType("error")
                setAlertMessage(tSelfAssist('dominio_valido'))
                setShowAlert(true);
                return;
            }

            // Cria um novo objeto de usuário com apenas o e-mail
            const newUser = {
                email: email
            };

            // Adiciona à lista temporária
            setTempUsersList(prev => [...prev, newUser]);
            setSearchTerm(""); // limpa o campo
            //alert(`Usuário adicionado com sucesso!`);
            setAlertTitle("Sucesso");
            setAlertType("sucess")
            setAlertMessage(tSelfAssist('add_sucess'))
            setShowAlert(true);
            setShowAddUserModal(false); // fecha o modal
        } else {
            // Lógica original para buscar usuários existentes
            const alreadyExists = allUsers.some(u => u.email === email);
            if (alreadyExists) {
                //alert("Usuário já está na lista.");
                setAlertTitle("Aviso");
                setAlertType("info")
                setAlertMessage(tSelfAssist('user_exist'))
                setShowAlert(true);
                return;
            }
        }
    };

    const handleAddByEmail = async () => {
        const email = emailToAdd.trim();

        // Verifica se o e-mail é válido
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!isValidEmail) {
            setAlertTitle("Erro");
            setAlertType("error");
            setAlertMessage(tSelfAssist('email_valido'));
            setShowAlert(true);
            return;
        }

        if (!isAllowedDomain(email)) {
            setAlertTitle("Erro");
            setAlertType("error");
            setAlertMessage(tSelfAssist('dominio_valido'));
            setShowAlert(true);
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/put_update_users`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    assistant_id: assistantId,
                    users: [{ email }],
                    role: role,
                })
            });

            if (response.ok) {
                const updatedUsers = await response.json();
                setAllUsers(updatedUsers);
                setEmailToAdd("");
                setAlertTitle("Sucesso");
                setAlertType("success");
                setAlertMessage(tSelfAssist("add_sucess"));
                setShowAlert(true);
            } else {
                setAlertTitle("Erro");
                setAlertType("error");
                setAlertMessage(tSelfAssist("erro_salvar"));
                setShowAlert(true);
            }
        } catch (error) {
            console.error("Erro ao salvar usuários:", error);
            setAlertTitle("Erro");
            setAlertType("error");
            setAlertMessage(tSelfAssist("erro_salvar"));
            setShowAlert(true);
        }
    };

    const handleToggleUser = (user) => {
        if (user.email && !isAllowedDomain(user.email)) {
            setAlertType("error");
            setAlertTitle("Erro");
            setAlertMessage(`Domain not allowed`);
            setShowAlert(true);
            return;
        }

        setTempUsersList(prevUsers => {
            const userExists = prevUsers.some(u => u.email === user.email);
            if (userExists) {
                return prevUsers.filter(u => u.email !== user.email);
            } else {
                const userToAdd = user.user ? user : { email: user.email };
                return [...prevUsers, userToAdd];
            }
        });
    };

    const handleAddSelectedUsers = async () => {
        if (size === 'small') {
            console.log(tempUsersList)
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/put_update_users`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify({
                        assistant_id: assistantId,   
                        users: tempUsersList,       
                        role: role, 
                    })
                });

                if (response.ok) {
                    console.log(response)
                    const updatedUsers = await response.json();
                    setAllUsers(updatedUsers); 
                    setAlertTitle("Sucesso");
                    setAlertType("success");
                    setAlertMessage(tSelfAssist("add_sucess"));
                    setShowAlert(true);
                } else {
                    setAlertTitle("Erro");
                    setAlertType("error");
                    setAlertMessage(tSelfAssist("erro_salvar"));
                    setShowAlert(true);
                }
            } catch (error) {
                console.error("Erro ao salvar usuários:", error);
                setAlertTitle("Erro");
                setAlertType("error");
                setAlertMessage(tSelfAssist("erro_salvar"));
                setShowAlert(true);
            }

            setShowAddUserModal(false);
        }
        else {
            setShowAddUserModal(false);
        }

    };

    return (

        <div className={`add-user-modal ${size === 'small' ? 'add-user-modal-small' : ''}`}>

            <div className="add-user-header">
                <p>{tSelfAssist("add_user")}</p>
                <img src='/imagens/x-white.svg' alt={tCommon("closeButton")} className='close-button' onClick={() => setShowAddUserModal(false)} />
            </div>

            {/* Novo input: Adicionar via e-mail */}
            {size==='small' && (
            <div className="add-by-email-container">
                <input
                    type="text"
                    className={`add-by-email-input ${size === 'small' ? 'add-by-email-input-small' : ''}`}
                    placeholder={tSelfAssist("add_by_email")}
                    value={emailToAdd}
                    onChange={(e) => setEmailToAdd(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') handleAddByEmail(); }}
                    aria-label={tSelfAssist("add_by_email")}
                />
                <img src='/imagens/icon-email-send.svg' alt="Buscar" className='add-by-email-icon-btn' onClick={handleAddByEmail} />
            </div>
            )}

            <div className='publish-buttons-wrapper'>
                {showEmailModeButton && (
                    <button
                        className='adicionar-viaemail'
                        onClick={() => {
                            setAddByEmailMode(true);
                            setAllUsers([]);
                            setSearchTerm("");
                        }}
                    >
                        {tSelfAssist("add_by_email")}
                    </button>
                )}


                <div className="search-container-modal">
                    <input
                        type="text"
                        data-testid="search-input"
                        placeholder={addByEmailMode ? tSelfAssist("enter_email") : tCommon("search")}
                        className={`publish-input-modal ${size === 'small' ? 'publish-input-modal-small' : ''}`}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        onKeyDown={handleSearchEnter}
                    />

                    <div>
                        {showAlert && (
                            <AlertsCustom
                                type={alertType}
                                title={alertTitle}
                                message={alertMessage}
                                onClose={() => setShowAlert(false)}
                            />
                        )}
                    </div>

                    <img src='/imagens/search-white.svg' alt={tCommon("searchIcon")} className='search-icon' />
                </div>
            </div>

            <div className={`users-options-list ${size === 'small' ? 'users-options-list-small' : ''}`} data-testid="users-options-list">
                {!addByEmailMode ? (
                    Array.isArray(allUsers) && allUsers
                        .sort((a, b) => a.email.localeCompare(b.email))
                        .filter(user =>
                            user.user?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            user.email.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                        .map((user, i) => (
                            <div
                                data-testid="users-option"
                                className={`user-option ${size === 'small' ? 'user-option-small' : ''}`}
                                key={i}
                                onClick={() => handleToggleUser(user)}
                            >
                                <div className='modal-admin-avatar' title={user.user || user.email}>
                                    <div className="header__user-initial">
                                        {(user.user?.charAt(0) || user.email.charAt(0)).toUpperCase()}
                                    </div>
                                </div>
                                <div className='user-info'>
                                    <p title={user.email} className={`user-name ${size === 'small' ? 'user-name-small' : ''}`}>{user.user || tCommon("userWithoutName")}</p>
                                    <p className='user-email' title={user.email}>{user.email}</p>
                                </div>
                                {showEmailModeButton && (
                                    <p className='user-add-level'>{tCommon("user")}</p>
                                )}
                                <div className='custom-checkbox'>
                                    <img
                                        src={tempUsersList.some(u => u.email === user.email) ? '/imagens/checked-box.svg' : '/imagens/unchecked-box.svg'}
                                        alt={tCommon("checkboxIcon")}
                                        className={`checkbox-image ${size === 'small' ? 'checkbox-image-small' : ''}`}
                                    />
                                </div>
                            </div>
                        ))
                ) : (
                    // Mostra preview do card quando estiver no modo de adicionar por e-mail
                    searchTerm.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(searchTerm.trim()) && (
                        isAllowedDomain(searchTerm.trim()) ? (
                            // Renderiza o card normal se o domínio for permitido
                            <div className="user-option email-preview" onClick={() => handleToggleUser({ email: searchTerm.trim() })}>
                                <div className='modal-admin-avatar'>
                                    <div className="header__user-initial">
                                        {searchTerm.trim().charAt(0).toUpperCase()}
                                    </div>
                                </div>

                                <div className='user-info'>
                                    <p className='user-name'>{tSelfAssist("invitation_to")}</p>
                                    <p className='user-email'>{searchTerm.trim()}</p>
                                </div>

                                <div className='custom-checkbox'>
                                    <img
                                        src={tempUsersList.some(u => u.email === searchTerm.trim()) ? '/imagens/checked-box.svg' : '/imagens/unchecked-box.svg'}
                                        alt={tCommon("checkboxIcon")}
                                        className="checkbox-image"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="user-option email-preview invalid">
                                <div>
                                    <p>{tSelfAssist("domain_not_allowed")}</p>
                                </div>
                            </div>
                        )
                    )
                )}
            </div>
            <div className="central-button">
                <button data-testid='save-button' className={`white-button ${size === 'small' ? 'white-button-small' : ''}`} onClick={handleAddSelectedUsers}>
                    {tCommon("save")}
                </button>
            </div>

            {addByEmailMode && (
                <button className='voltar-lista' onClick={async () => {
                    setAddByEmailMode(false);
                    setSearchTerm("");
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}/get_list_users`, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        })
                        const users = await response.json();
                        setAllUsers(users);
                    } catch (error) {
                        console.error("Erro ao buscar usuários:", error);
                    }
                }}>
                    <p>{tSelfAssist("back_to_list")}</p>
                </button>
            )}

            
        </div>
    );
};

export default AddUserModal;